import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

const TawkTo = () => {
  const { lang } = useParams();
  const loaded = useRef(false);

  useEffect(() => {
    const widgetId = process.env.REACT_APP_TAWKTO_WIDGET_ID;
    if (!widgetId || loaded.current) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    window.Tawk_API.onLoad = function () {
      window.Tawk_API.setAttributes({
        language: lang || 'tr',
        page: window.location.pathname
      }, function () {});
    };

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://embed.tawk.to/${widgetId}`;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.head.appendChild(script);

    loaded.current = true;
  }, [lang]);

  useEffect(() => {
    if (window.Tawk_API && typeof window.Tawk_API.setAttributes === 'function') {
      window.Tawk_API.setAttributes({
        language: lang || 'tr',
        page: window.location.pathname
      }, function () {});
    }
  }, [lang]);

  return null;
};

export default TawkTo;
